import { useMsal } from '@azure/msal-react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

// Landing page after an Entra sign-out, so the user isn't bounced straight back
// into the login flow.
export default function LoggedOutPage() {
  const { instance } = useMsal();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        bgcolor: 'background.default'
      }}
    >
      <Paper sx={{ p: 3, width: '100%', maxWidth: 420 }}>
        <Stack spacing={3} alignItems="center" textAlign="center">
          <Box
            component="img"
            src="/assets/BakerLogo.svg"
            alt="The Baker Group"
            sx={{ width: 160, height: 'auto', objectFit: 'contain' }}
          />
          <Typography variant="h5">You've been signed out</Typography>
          <Button fullWidth variant="contained" onClick={() => instance.loginRedirect()}>
            Sign back in
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
